function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".AddUser-1{fill:#16224a;}.AddUser-2{fill:none;stroke:#16224a;stroke-miterlimit:10;stroke-width:0.5px;}"));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "AddUser-1",
  cx: 4.2,
  cy: 2.4,
  r: 2.4
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "AddUser-1",
  d: "M6.88,7.6H6.57a3.28,3.28,0,0,1-2.74,0H3.52A2.52,2.52,0,0,0,1,10.12v.78a.9.9,0,0,0,.9.9H7.05a.9.9,0,0,1,0-.4l.12-1.14,0-.21L7.3,9.9,8.75,8.45A2.48,2.48,0,0,0,6.88,7.6Z",
  transform: "translate(-1 -2.2)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "AddUser-1",
  d: "M1.65,8.45,3.1,9.9l.15.15,0,.21L3.4,11.4a.78.78,0,0,1,0,.4H8.51a.9.9,0,0,0,.9-.9v-.78A2.52,2.52,0,0,0,6.89,7.6H6.57a3.23,3.23,0,0,1-1.36.3,3.31,3.31,0,0,1-1.37-.3H3.53A2.5,2.5,0,0,0,1.65,8.45Z",
  transform: "translate(-1 -2.2)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "AddUser-1",
  d: "M11.07,5.17h-.81V4.36a.18.18,0,0,0-.18-.18H9.9a.18.18,0,0,0-.18.18v.81H8.91a.18.18,0,0,0-.18.18v.18a.18.18,0,0,0,.18.18h.81v.81a.18.18,0,0,0,.18.18h.18a.18.18,0,0,0,.18-.18V5.71h.81a.18.18,0,0,0,.18-.18V5.35A.18.18,0,0,0,11.07,5.17Z",
  transform: "translate(-1 -2.2)"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  className: "AddUser-2",
  cx: 8.99,
  cy: 3.24,
  r: 1.93
});

var SvgAddUser = function SvgAddUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AddUser",
    "data-name": "AddUser 1",
    viewBox: "0 0 11.17 9.6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AddUser.6d5fa157.svg";
export { ForwardRef as ReactComponent };